import {
    animated, config, useSpring
} from '@react-spring/web'
import { useMemo, useState } from 'react';
import { IoIosArrowDown } from 'react-icons/io'
import { useAppState } from '../../providers/app-state';
import ProductListDropdown from './product-list-dropdown';

const ProductListItem = ({ secondaryCategory, style, openSidebar }) => {
    const { state } = useAppState();
    const [isOpen, setIsOpen] = useState(false)

    const caretSpring = useSpring({
        config: config.stiff,
        transformOrigin: "center",
        transform: isOpen ? "rotate(0deg)" : "rotate(-180deg)"
    })

    const headingSpring = useSpring({
        config: config.stiff,
        backgroundColor: isOpen ? "#003854" : "white",
        borderRadius: isOpen ? "6px 6px 0px 0px" : "6px 6px 6px 6px",
        color: isOpen ? "white" : "#003854",
    })

    secondaryCategory.childs.map(child => {
        child.products.map(product => {
            console.log(product)
        })
    })

    const hasCampaign = useMemo(() => {
        let flag = false;
        secondaryCategory.childs.forEach(child => {
            child.products.forEach(product => {
                if (product.campaign) {
                    flag = true;
                }
            })
        })
        return flag;
    }, [secondaryCategory])

    //Checks how many products of the category is selected. To show a count.
    const selectedAmount = useMemo(() => {
        return state.selectedRepairs.filter(r => r.categoryId === secondaryCategory.id).length
    }, [state.selectedRepairs, secondaryCategory.id])

    return (
        <>
            <animated.div
                className="flex flex-row items-center shadow-lg p-4 border-l-skgBlue border-l-8 mt-5 z-0 space-x-4 cursor-pointer"
                style={{
                    ...style,
                    ...headingSpring
                }}
                onClick={() => {
                    setIsOpen(p => !p)
                }}
            >
                <div
                    className={`icon ${secondaryCategory.icon} text-3xl flex items-center`}
                />
                <span
                    className="flex-1"
                >
                    <div
                        className="flex flex-row space-x-3"
                    >
                        <p>
                            {secondaryCategory.name}
                        </p>
                        {
                            hasCampaign && (

                                <span
                                    className='ml-1 text-xs bg-skgRed py-1 px-2 rounded-md text-white italic max-h-6 max-w-[80px]'
                                >
                                    Kampagne
                                </span>
                            )
                        }
                    </div>
                    {
                        !!selectedAmount && (
                            <div
                                className="text-sm text-skgRed"
                            >
                                {
                                    selectedAmount + " valgt"
                                }
                            </div>
                        )
                    }

                </span>
                <animated.span style={caretSpring} className="flex items-center justify-center">
                    <IoIosArrowDown />
                </animated.span>
            </animated.div>
            <ProductListDropdown
                open={isOpen}
                childs={secondaryCategory.childs}
                openSidebar={openSidebar}
            />
        </>
    )
}

export default ProductListItem;